export const USER_ROLES = ["SuperAdmin", "OrgAdmin", "Viewer"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export function isUserRole(v: string): v is UserRole {
  return (USER_ROLES as readonly string[]).includes(v);
}

export interface RoleOption {
  value: UserRole;
  label: string;
}

const ALL_ROLES: RoleOption[] = [
  { value: "Viewer", label: "Viewer" },
  { value: "OrgAdmin", label: "Org Admin" },
  { value: "SuperAdmin", label: "Super Admin" },
];

/** Returns the subset of role options that the calling user is allowed to assign. */
export function rolesAssignableBy(
  callerRole: UserRole | undefined,
): RoleOption[] {
  if (callerRole === "SuperAdmin") return ALL_ROLES;
  if (callerRole === "OrgAdmin")
    return ALL_ROLES.filter((r) => r.value !== "SuperAdmin");
  return ALL_ROLES.filter((r) => r.value === "Viewer");
}

export const ROLE_LABELS: Record<UserRole, string> = {
  SuperAdmin: "Super Admin",
  OrgAdmin: "Org Admin",
  Viewer: "Viewer",
};
